import React from 'react'

function Spinner() {
  return (
    <div className='custom-loader absolute left-[50%] top-[40%] '></div>
  )
}

export default Spinner